<template>
  <img
    src="@/assets/sar-symbol.svg"
    alt="SAR"
    class="sar-symbol"
    :style="{ height: size, width: 'auto' }"
  >
</template>

<script>
export default {
  name: 'SarSymbol',
  props: {
    size: {
      type: String,
      default: '1em'
    }
  }
}
</script>

<style scoped>
.sar-symbol {
  display: inline-block;
  vertical-align: middle;
  margin-inline-end: 4px;
}
</style>